import React from "react";
//import { HashRouter as Router, Route, Routes } from "react-router-dom";  // Usamos HashRouter
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Navbar from "./Navbar";
import ProductCatalog from "./ProductCatalog";
import ProductDetail from "./ProductDetail";


function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        {/* Navbar */}
        <Navbar />
        
        {/* Contenido principal */}
        <div className="">
          <Routes>
            <Route path="/" element={<ProductCatalog />} />
            <Route path="/productos/:categoria" element={<ProductCatalog />} />
            <Route path="/productos" element={<ProductCatalog />} />
            <Route path="/producto/:productId" element={<ProductDetail />} />
          </Routes>
        </div>

        {/* <div className="container mb-4">
          <div style={{ width: "100%", height: "350px" }}>
            <iframe
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              src="https://www.google.com/maps?q=12.1186756,-86.258196&z=17&t=m&output=embed"
            ></iframe>
          </div>
        </div> */}

        {/* Footer elegante */}
        <footer className="text-light text-center py-4 mt-auto is-size-10" style={{ backgroundColor: "#00377b" }}>
          <div className="container">
            <p className="mb-1">&copy; 2025, RYC Soluciones Nicaragua. Todos los derechos reservados.</p>

            {/* Redes sociales */}
            <div className="d-flex justify-content-center gap-3 mb-2">
            <a
              href="https://www.facebook.com/RYCsolucionesNicaragua?locale=es_LA"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex justify-content-center align-items-center p-2"
              style={{
                backgroundColor: "white", // Fondo blanco del cuadro
                color: "#00377b", // Color azul para el ícono
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.3)", // Sombra
                borderRadius: "20%", // Hace el cuadro redondo
                width: "30px", // Tamaño del botón
                height: "30px",
                textDecoration: "none",
              }}
            >
              <i className="fab fa-facebook-f fa-lg"></i>
            </a>


             {/*  <a href="" target="_blank" rel="noopener noreferrer" className="text-light">
                <i className="fab fa-x-twitter fa-lg"></i>
              </a>
              <a href="s" target="_blank" rel="noopener noreferrer" className="text-light">
                <i className="fab fa-instagram fa-lg"></i>
              </a>
              <a href="" target="_blank" rel="noopener noreferrer" className="text-light">
                <i className="fab fa-youtube fa-lg"></i>
              </a> */}
            </div>
          </div>
        </footer>
        {/* Modal de contacto */}
        <div
          className="modal fade"
          id="contactModal"
          tabIndex="-1"
          aria-labelledby="contactModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content border-0 shadow-lg">
              
              <div className="modal-header bg-primary text-light">
                <img
                  src="https://ryc-soluciones-nicaragua.com/imagenes/cropped-cropped-logo-editable-192x192.png"
                  alt="RYC Logo"
                  style={{ width: "36px", height: "36px", marginRight: "10px" }}
                />
                <h5 className="modal-title" id="contactModalLabel">Contáctanos</h5>
                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Cerrar"></button>
              </div>

              <div className="modal-body">
                
                {/* Mapa */}
                <div style={{ width: "100%", height: "400px", borderRadius: "8px", overflow: "hidden" }}>
                  <iframe
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    src="https://www.google.com/maps?q=12.1186756,-86.258196&z=17&t=m&output=embed"
                  ></iframe>
                </div>

                {/* Dirección */}
                {/* <div className="mt-3 p-3 bg-light rounded shadow-sm">
                  <p className="mb-1"><strong>Dirección:</strong> Km 4 Carretera Masaya, Colegio Teresiano 1c al Este, Managua, Managua, Nicaragua</p>
                  <p className="mb-0"><strong>Teléfono:</strong> 7700 5446</p>
                </div> */}

                {/* Imagen de la sucursal */}
                <div className="mt-3">
                  <img
                    src="https://ryc-soluciones-nicaragua.com/imagenes/imagen_ubicacion.jpeg"
                    alt="Sucursal"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      objectFit: "cover"
                    }}
                  />
                </div>

              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  Cerrar
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
